<template>
  <div class="z-20 w-full h-full items-center pb-0 outline-none box-border flex flex-col justify-center absolute inset-0">
    <instruction :instruction="instruction" @action="handleActionButton"></instruction>
  </div>
</template>

<script>
import Instruction from '@/components/Instruction.vue'
import surveyMixin from '../mixins/surveyMixin';
import translateMixin from '../mixins/translateMixin';

  export default {
    mixins: [surveyMixin, translateMixin],
    data() {
      return {
      instruction: {}
      }
    },
    components: {
      Instruction
    },
    watch: {
      '$route': async function () { await this.populatePageData('instruction', this.$route.params) }
    },
    methods: {
      // handleActionButton (in surveyMixin)
      // populatePageData (in surveyMixin)
    },
    async created () {
      await this.populatePageData('instruction', this.$route.params)
    }
  }
</script>
